import React, { useState, useEffect } from "react";
import ReactDOm from "react-dom";
import { useNavigate } from "react-router-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import { addParticularCompany, addUser, addUserCompanyAccess } from "../../utils/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useFetchCompanyListQuery } from "../../utils/company/companySelector";
import "react-loading-skeleton/dist/skeleton.css";
import useDebouncedEffect from "../customer/useDebouncedEffect";
import { useLazyFetchCompanyPermissionsQuery } from "../../utils/customer/customerTable";
import { getFormatDate } from "../../utils/utilityFunctions/dateUtility";
import Loader from "../UniversalComponents/Loader";
import { pushAlert } from "../../utils/alertSlice";
import { getCompanyId, getOrganizationId, getUserToken } from "../../utils/utilityFunctions/localServices";
import { CHECK_IS_OWNER } from "../../utils/constants";
import EditIcon from "../../assets/images/disableImg.svg";
import moment from "moment";
import Company from "../Onboarding/components/AddCompany/components/Company";

const Options = () => {
  const user = useSelector((state) => state.user);
  const Navigate = useNavigate();
  const { token } = useRequireAuth();
  const dispatch = useDispatch();
  const [showDeleteButton, setShowDeleteButton] = useState(null);
  let userToken = token || JSON.parse(localStorage.getItem("myUserData")).token;
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [queryParams, setQueryParams] = useState({
    pagination: `page=${currentPage}`,
    token: userToken,
  });
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [menuKey, setMenuKey] = useState(0);
  const [ispermission, setIspermission] = useState(null);
  const [company, setCompany] = useState([]);

  const { data: companyCommnData, error, isLoading, refetch: CompanyDataRefech } = useFetchCompanyListQuery(userToken);

  const [fetchCompanyPermissions, { data: companyPermissionsData, isSuccess: companyPermissionsSuccess }] =
    useLazyFetchCompanyPermissionsQuery();

  useEffect(() => {
    if (companyPermissionsData) updateAndNagivate();
  }, [companyPermissionsData, companyPermissionsSuccess]);

  useEffect(() => {
    CompanyDataRefech();
    if (companyCommnData) {
      setCompany(companyCommnData?.data);
    }
  }, [companyCommnData, userToken]);

  useDebouncedEffect(
    () => {
      setQueryParams({
        pagination: `page=${currentPage}`,
        token: userToken,
      });
    },
    500,
    [currentPage, userToken]
  );
  console.log("companyCommnData vinay", company);
  useEffect(() => {
    setLoading(true);
  }, [queryParams]);

  const handleClick = () => {
    // Navigate("/add_company");
    Navigate("/onboard_company");
  };

  const handleLoginClick = async (companyId, company_name, company_logo, owner) => {
    await dispatch(
      addParticularCompany({
        company_id: companyId,
        company_name: company_name,
        company_logo: company_logo,
        menuName: "",
        owner: owner,
      })
    );

    const DataAwait = await fetchCompanyPermissions({ token: token, companyId: companyId });

    if (DataAwait?.error?.data?.error) {
      setIspermission(DataAwait?.error?.data?.error);
      setAlert({
        visible: true,
        message: DataAwait?.error?.data?.error,
        type: "error",
      });
      dispatch(pushAlert({ message: DataAwait?.error?.data?.error, type: "danger", visible: true }));
    } else {
      setIspermission(null);
    }

    fetch(`${CHECK_IS_OWNER}?org_id=${getOrganizationId()}&company_id=${getCompanyId()}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getUserToken()}`,
      },
    })
      .then((res2) => res2.json())
      .then((owernAcces) => {
        localStorage.setItem("ownerInfo", JSON.stringify({ isOwner: owernAcces.isOwner }));
      });
  };

  const updateAndNagivate = async () => {
    console.log("companyPermissionsData update", companyPermissionsData);
    await dispatch(addUserCompanyAccess(companyPermissionsData.data));

    await setMenuKey((prevKey) => prevKey + 1);
    Navigate("/customers");
  };

  const handleMouseEnter = (id) => {
    setShowDeleteButton(id);
  };

  const handleMouseLeave = () => {
    setShowDeleteButton(null);
  };
  const centeredLoader = () => (
    <div className="bg-container-spinner min-h-[200px]">
      <div className="spinner">Loading...</div>
    </div>
  );
  //if (isLoading) return centeredLoader();

  const getUserAccess = (value) => {
    const accessFlag = user?.permissions?.find((ob) => ob?.sub_module === value)?.permission;
    return accessFlag === 1;
  };

  return (
    <>
      <Loader isOpen={isLoading} />
      <div className="w-9/12 mt-11  ">
        {/* {ispermission && <p className="text-center text-red-500">{ispermission}</p>} */}
        {getUserAccess("Add Company") && (
          <div className="w-11/12">
            <button
              className="w-full  bg-white rounded-[5px] hover:border hover:border-[#2999BC]  hover:shadow-md h-[50px] font-400 text-center text-2999BC createCmp text-20 mb-4"
              onClick={handleClick}
            >
              + Add Company
            </button>
          </div>
        )}
        <div className="customscrollbar h-[calc(100vh-170px)] overflow-auto ">
          {Array.isArray(company) &&
            company.map((ProfileData) => (
              <div
                key={ProfileData?.id}
                className="flex "
                onMouseEnter={() => handleMouseEnter(ProfileData?.id)}
                onMouseLeave={handleMouseLeave}
              >
                <div className="flex mb-3 w-11/12 ">
                  <div className="visible bg-white text-14 text-545B61 font-400 hover:bg-1D4469 group hover:text-white rounded-[5px] border h-[65px] border-2c495d33 border-opacity-20 text-left px-5 hover:text-left w-full  cbtn-transition-bg">
                    <div className="flex justify-between items-center px-3 py-1 w-full">
                      <div className=" relative">
                        <text className="w-3/5 text-xl font-normal ">
                          {ProfileData.company_name}{" "}
                          {/* {showDeleteButton === ProfileData.id && "|| " + moment(ProfileData.created_at, "YYYY-MM-DD").format("DD-MM-YYYY")} */}
                        </text>
                      </div>
                      <div className="visble w-fit gap-3 ">
                        <button
                          className="rounded-full mr-2 p-3 hover:bg-[#E2EBF326] "
                          onClick={() => Navigate(`/edit_company/${ProfileData?.id}`)}
                        >
                          <img className="hidden group-hover:block cursor-pointer" src={EditIcon} />
                        </button>
                        <button
                          className=" my-2 py-1 px-5 border border-DFDFDF rounded-sm justify-center option-log items-center gap-2.5 hover:rounded-full hover:bg-white hover:text-1D5D9B "
                          onClick={() =>
                            handleLoginClick(
                              ProfileData?.id,
                              ProfileData?.company_name,
                              ProfileData?.company_logo,
                              ProfileData?.owner
                            )
                          }
                        >
                          <div className=" text-20 font-400 text-434343 font-['Poppins'] hover:text-1D5D9B ">
                            Launch
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="mt-16 hid ">
                    <button>
                      <i className=" text-orange-400 text-xl shadow-md p-3 bi bi-trash3 bg-white rounded-md"></i>
                    </button>
                  </div>
                </div>
                {/* <div className={`flex items-center ${showDeleteButton === ProfileData.id ? "visible m-0" : "invisible m-0"}`}>
                              <button className="rounded border-1 border-BFBFBF bg-white p-2 ms-5">
                                  <i className="bi bi-trash3 text-D93916"></i>
                              </button>
                          </div> */}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default Options;
